export default function (Component) {
  const _Component = Component
  _Component.__i18n = _Component.__i18n || []
  _Component.__i18n.push({
    "locale": "",
    "resource": {
      "en": {
        "add": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Add member"])},
        "role": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Role"])},
        "user": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["User"])},
        "no_results_found": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sorry, no matches found"])},
        "error_warning": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cannot save: see error messages above"])}
      },
      "fr": {
        "add": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ajouter un membre"])},
        "role": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Rôle"])},
        "user": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Utilisateur"])},
        "no_results_found": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Désolé, aucune correspondance n'a été trouvée"])},
        "error_warning": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Impossible de sauver: voyez les messages d'erreur ci-dessus"])}
      }
    }
  })
}